import { createSelector } from 'reselect'

export const getRegistrationPremiumClasses = createSelector(state => state && state.ads.detail &&
state.ads.detail.registrationPremiumClasses ? state.ads.detail.registrationPremiumClasses : [],
registrationPremiumClasses => registrationPremiumClasses
)
